
import { fetchWithToken, getAccessToken } from "./accessToken";

export const UploadImage = async (formData) => {
    try {
      formData.append("need_thumbnail", true);
      const response = await fetchWithToken(`${localStorage.getItem("apiDomain")}/api/file_manager/image/`, {
        method: "POST",
        body: formData,
        headers: {
          "x-api-key": localStorage.getItem("apiKey") || "",
          "Authorization": localStorage.getItem("accessToken") || ""
        }
      });
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.detail);
      }
      return data;
    } catch (error) {
      throw error;
    }
};


export const GetImageFolderList = async (fileKey: string, fileNameKey = "") => {
  try {
    const response = await fetchWithToken(`${localStorage.getItem("apiDomain")}/api/file_manager/image_and_folder/?file_key=${fileKey}&file_name_key=${fileNameKey===undefined? "": fileNameKey}`, {
      method: "GET",
      headers: {
        "x-api-key": localStorage.getItem("apiKey") || "",
        "Authorization": localStorage.getItem("accessToken") || ""
      }
    });
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const DelImage = async (imageId) => {
  try {
    const response = await fetchWithToken(`${localStorage.getItem("apiDomain")}/api/file_manager/image/`, {
      method: "DELETE",
      body: JSON.stringify({"image_id": imageId}),
      headers: {
        "x-api-key": localStorage.getItem("apiKey") || "",
        "Authorization": localStorage.getItem("accessToken") || "",
        'Content-Type': 'application/json'
      }
    });
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const DelFolder = async (folderId) => {
  try {
    const response = await fetchWithToken(`${localStorage.getItem("apiDomain")}/api/file_manager/folder/`, {
      method: "DELETE",
      body: JSON.stringify({"folder_id": folderId}),
      headers: {
        "x-api-key": localStorage.getItem("apiKey") || "",
        "Authorization": localStorage.getItem("accessToken") || "",
        'Content-Type': 'application/json'
      }
    });
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.detail);
    }
    return data;
  } catch (error) {
    throw error;
  }
};

export const CreateFolder = async (bodyData) => {
  try {
    const response = await fetchWithToken(`${localStorage.getItem("apiDomain")}/api/file_manager/folder/`, {
      method: "POST",
      body: JSON.stringify(bodyData),
      headers: {
        "x-api-key": localStorage.getItem("apiKey") || "",
        "Authorization": localStorage.getItem("accessToken") || "",
        'Content-Type': 'application/json'
      }
    });
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.detail);
    }
    return data;
  } catch (error) {
    throw error;
  }
};

export const listLandingPage = async (params, requestInfo: any = {}) => {
  try {
    const response = await fetch(`${localStorage.getItem("apiDomain")}/api/portal_manager/landing_page/list/?division=${requestInfo.divisionId}&order_by=-modified_at&page_size=50&name__icontains=${params.name__icontains}`, {
      method: "GET",
      headers: {
        "x-api-key": localStorage.getItem("apiKey") || "",
        "domain": requestInfo.domain,
        "Authorization": getAccessToken(),
      },
    });
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const data = await response.json();
   
    const formatedData = data?.results?.map((x: any) => ({
        label: x.name,
        value: x.url,
    }));
    return formatedData;
  } catch (error) {
    throw error;
  }
};

export const PreviewToken = async (apiDomain, token, requestUrl, version="1") => {
  try {
    const apiLink = apiDomain ? apiDomain: localStorage.getItem("apiDomain");
    const response = await fetch(`${apiLink}/api/portal_manager/preview/${token}/?request_url=${requestUrl}&version=${version}`, {
      method: "GET",
    });
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};